var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-button',_vm._g(_vm._b({directives:[{name:"close-popover",rawName:"v-close-popover",value:(!_vm.keepOpen),expression:"!keepOpen"}],staticClass:"btn--dropdown-item"},'v-button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }